import { useState, useEffect } from "react";
import ChangePassword from "../../components/user/Settings/ChangePassword";
import ChangeEmail from "../../components/user/Settings/ChangeEmail";
import HideBioToggle from "../../components/user/Settings/Privacy";
import { userService } from "../../services";

const SettingsPage = () => {
  const [user, setUser] = useState({ email: "", privacyMode: null });

  useEffect(() => {
    async function getUser() {
      try {
        const userData = await userService.myProfile("me");
        setUser({ email: userData.email, privacyMode: userData.privacyMode });
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    }
    getUser();
  }, []);

  // Toggle privacy and update profile
  const togglePrivacy = async () => {
    const updatedPrivacy = !user.privacyMode;
    setUser((prev) => ({ ...prev, privacyMode: updatedPrivacy }));

    try {
      const updateUser = await userService.UpdateProfile("me", { privacyMode: updatedPrivacy });
      if (updateUser) {
        console.log("Privacy Changed!");
      }
    } catch (error) {
      console.error("Error updating privacy:", error);
      setUser((prev) => ({ ...prev, privacyMode: !updatedPrivacy })); // Revert on failure
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg">
      <h2 className="text-xl font-semibold mb-4">Settings</h2>
      {/* Pass props to HideBioToggle */}
      <HideBioToggle privacyMode={user.privacyMode} togglePrivacy={togglePrivacy} />
      <ChangePassword email={user.email} />
      <ChangeEmail email={user.email} />
    </div>
  );
};

export default SettingsPage;
